// src/features/wbs/editor/components/WbsEmptyState.tsx
import React from "react";

export default function WbsEmptyState({ onCreateRoot, onImport, onTemplate }: {
  onCreateRoot: () => void;
  onImport: () => void;
  onTemplate: () => void;
}) {
  return (
    <div className="h-full grid place-items-center p-8">
      <div className="text-center space-y-4">
        <h2 className="text-xl font-semibold">아직 WBS가 없습니다</h2>
        <p className="text-sm text-gray-500">첫 항목을 만들거나, 템플릿/엑셀로 시작할 수 있어요.</p>
        <div className="flex items-center justify-center gap-2">
          <button className="px-4 py-2 rounded-2xl bg-orange-500 text-white" onClick={onCreateRoot}>WBS 생성 시작</button>
          <button className="px-4 py-2 rounded-2xl border" onClick={onTemplate}>템플릿으로 시작</button>
          <button className="px-4 py-2 rounded-2xl border" onClick={onImport}>엑셀/CSV 가져오기</button>
        </div>
      </div>
    </div>
  );
}
